module.exports = __webpack_public_path__ + "images/emoji/rice.1165f13df11cbeca22a3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rice.png
// module id = Rzgq
// module chunks = 2